import React from 'react'
import { heightPercentageToDP, widthPercentageToDP } from '../../../Utils/ResponsiveScreen'

const styles = {
	fontSize: {
		fontSize: '12px',
	},
	mandatoryErrorText: {
		fontSize: heightPercentageToDP('2'),
		color: 'red',
	},
}

function MandatoryValidations(props) {
	return (
		<details
			style={{ marginLeft: widthPercentageToDP('2'), marginBottom: heightPercentageToDP('2') }}
		>
			<summary>
				<text
					style={{
						fontSize: heightPercentageToDP('1.4'),
						color: 'red',
					}}
				>
					{'Missing Mandatory fields'}
				</text>
			</summary>

			{props.totalContentMissingFields.map((item, index) => {
				return (
					<div key={index}>
						<text style={styles.mandatoryErrorText}>{`${item}`}</text>
					</div>
				)
			})}
		</details>
	)
}

export default MandatoryValidations
